// tslint:disable
export var DiagnosisType;
(function (DiagnosisType) {
    // UNKN
    DiagnosisType[DiagnosisType["UNKN"] = 0] = "UNKN";
    // ICD9
    DiagnosisType[DiagnosisType["ICD9"] = 1] = "ICD9";
    // ICD10
    DiagnosisType[DiagnosisType["ICD10"] = 2] = "ICD10";
    // DSM4
    DiagnosisType[DiagnosisType["DSM4"] = 3] = "DSM4";
    // J-CODE
    DiagnosisType[DiagnosisType["JCODE"] = 4] = "JCODE";
    // CPT Code
    DiagnosisType[DiagnosisType["CPTCode"] = 5] = "CPTCode";
    // Q-CODE
    DiagnosisType[DiagnosisType["QCODE"] = 6] = "QCODE";
})(DiagnosisType || (DiagnosisType = {}));
DiagnosisType['CPTCODE'] = 5;
//# sourceMappingURL=DiagnosisType.js.map